import { createSingleton } from '../utilities/singleton';
import {
  GeoJson2SvgDrawWorkerInput,
  GeoJson2SvgDrawWorkerOutput,
} from '../workers/geojson2SvgDraw.worker';
import { useWebWorker, WebWorker } from './useWebWorker';

const GeoJson2SvgDrawWorker = WebWorker.bind<
  [() => Worker],
  [],
  WebWorker<GeoJson2SvgDrawWorkerInput, GeoJson2SvgDrawWorkerOutput>
>(
  WebWorker,
  () =>
    new Worker(new URL('../workers/geojson2SvgDraw.worker.ts', import.meta.url))
);

const singleton = createSingleton(
  () => new GeoJson2SvgDrawWorker(),
  (worker) => worker.terminate()
);

export const useGeoJson2SvgDrawWorker = (
  setLoading?: (loading: boolean) => void
) => useWebWorker(singleton(), setLoading);
